/**
 * Wave logic utilities for Discovery feed (no external deps).
 *
 * PRODUCT INTENT (current mode)
 * ----------------------------------------
 * - Premium users:
 *     STRICT (1) → WIDER (2) → EXPLORE (3)
 *   (no BASE/0 for premium)
 * - Non-premium users:
 *     BASELINE (0) only
 */

// Tiny logger used instead of a toast library (keeps build zero-dependency)
function logWaveMessage(msg) {
  try {
    // eslint-disable-next-line no-console
    console.log(`[Wave] ${msg}`);
  } catch {
    /* no-op */
  }
}

export const WAVE = Object.freeze({
  BASE: 0,
  STRICT: 1,
  WIDER: 2,
  EXPLORE: 3,
});

/**
 * Determine the sequence of waves to try.
 * Premium: 1 → 2 → 3
 * Non-premium: 0
 */
export function getValidWaves(isPremium) {
  if (!isPremium) return [WAVE.BASE, WAVE.WIDER, WAVE.EXPLORE]; // non-premium → [0]
  return [WAVE.STRICT, WAVE.WIDER, WAVE.EXPLORE]; // premium → [1, 2, 3]
}

/**
 * Pick the initial wave to start from.
 */
export function getStartWave(isPremium) {
  return isPremium ? WAVE.STRICT : WAVE.BASE;
}

export function coerceWaveToValid(wave, validWaves) {
  return validWaves.includes(wave) ? wave : validWaves[0];
}

export function toastWaveChange(wave) {
  const messages = {
    [WAVE.BASE]: "Showing matches based on your basic preferences.",
    [WAVE.STRICT]: "Applying your detailed filters for a more precise match.",
    [WAVE.WIDER]: "We widened the age range to find more options.",
    [WAVE.EXPLORE]: "Showing broader matches so you don’t run out.",
  };
  logWaveMessage(messages[wave] ?? "Updating your recommendations…");
}
